import React, { useEffect, useState } from 'react'
import { func, number, string } from 'prop-types'
import styled from 'styled-components'
import Select from '@taglivros/oef_componentes/build/components/select'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import { PARCELAS_PAGAMENTO_ANUAL, PARCELAS_PAGAMENTO_TRIMESTRAL, TITULO_ESCOLHA_PARCELA } from './constantsEscolhaParcelas'
import { PARCELA_PADRAO_ANUAL, PARCELA_PADRAO_TRIMESTRAL } from '../FluxosPagamento/constantsFluxosPagamento'
import { PLANO_ANUAL } from '../../constants'

const WrapperEscolhaParcelas = styled.div`
  margin-top: 15px;

  h6 {
    ${StyleGuide.tipografia.textoDefault}
    color: ${StyleGuide.cores.cinza300};
    margin: 5px 0;
  }

  p {
    ${StyleGuide.tipografia.textoDefault}
  }
`

const EscolhaParcelas = ( { parcelaEscolhidaExterna, onConfirmar, plano } ) => {
  const parcelaPadrao = plano === PLANO_ANUAL.visualizacao ? PARCELA_PADRAO_ANUAL : PARCELA_PADRAO_TRIMESTRAL
  const [ parcelaEscolhida, setParcelaEscolhida ] = useState( parcelaPadrao.value )
  const [ valorParcelado, setValorParcelado ] = useState( parcelaPadrao.visulização )

  useEffect( () => {
    if ( ( parcelaEscolhida || parcelaEscolhida === 0 ) && onConfirmar ) {
      onConfirmar( parcelaEscolhida, valorParcelado )
    }
  }, [ parcelaEscolhida ] )

  useEffect( () => {
    if ( parcelaEscolhidaExterna ) {
      setParcelaEscolhida( parseInt( parcelaEscolhidaExterna, 10 ) )
    }
  }, [ parcelaEscolhidaExterna ] )

  const handleChange = event => {
    if ( event ) {
      const { value, visualizacao } = event
      if ( value ) {
        setParcelaEscolhida( value )
        setValorParcelado( visualizacao )
      }
    } else {
      setParcelaEscolhida( 0 )
    }
  }

  return (
    <WrapperEscolhaParcelas>
      <h6>{ TITULO_ESCOLHA_PARCELA }</h6>

      <Select
        defaultOption={ plano === PLANO_ANUAL.visualizacao ? PARCELA_PADRAO_ANUAL : PARCELA_PADRAO_TRIMESTRAL }
        itens={ plano === PLANO_ANUAL.visualizacao ? PARCELAS_PAGAMENTO_ANUAL : PARCELAS_PAGAMENTO_TRIMESTRAL }
        label=""
        onChange={ handleChange }
      />
    </WrapperEscolhaParcelas>
  )
}

EscolhaParcelas.defaultProps = {
  'onConfirmar': null,
  'parcelaEscolhidaExterna': null
}

EscolhaParcelas.propTypes = {
  'onConfirmar': func,
  'parcelaEscolhidaExterna': number,
  'plano': string.isRequired
}

export default EscolhaParcelas
